import _get from "lodash/get";
import _isEmpty from 'lodash/isEmpty';
import { channels } from '../routes/views/Constants';

export const orderSlots = (adOrder = {}) => {
  return Object.entries(adOrder)
    .map(([slot, priority], index) => ({
      slotLower: slot.toLowerCase(),
      priority,
      index,
    }))
    .sort((a, b) => {
      if (a.priority !== b.priority) return a.priority - b.priority;
      return a.index - b.index;
    });
};

export function getOsmosAdsInOrder(bannerDetails = {}, adOrder = {}) {
  const{ ads ={} } = bannerDetails;
  if (!ads) return [];

  const normalizedOrder = orderSlots(adOrder);
  const bannerAdsLower = {};
  for (const key in ads) {
    bannerAdsLower[key.toLowerCase()] = ads[key];
  }

  const finalAds = [];

  for (const entry of normalizedOrder) {
    const slot = entry.slotLower;
    const adsForSlot = bannerAdsLower[slot];

    if (Array.isArray(adsForSlot)) {
      for (const ad of adsForSlot) {
        finalAds.push({
          uclid: ad.uclid,
          cid: ad.client_id,
          slot,
          priority: entry.priority,
          imptrackers: [ad.impression_tracking_url],
          clktrackers: [ad.click_tracking_url],
          redirect_url: ad.elements.destination_url,
          customimage: [
            {
              "1024x320": _get(ad, "elements.desktop_image", ""),
              "1440x178": _get(ad, "elements.desktop_image", ""),
              "512x910": _get(ad, "elements.mobile_image", "")
            }
          ],
          ctafb: _get(ad, "elements.destination_url", ""),
          title: _get(ad, "elements.headline", ""),
          ctatext: _get(ad, "elements.cta", ""),
          desc2: ad.crt,
          adSource: 'OSMOS'
        });
      }
    }
  }

  return finalAds;
}

function compactArrayofObjects(arr = []) {
  return arr?.filter(element => Object.keys(element)?.length !== 0);
}

function cmsAndOsmosAdsBannersMergerUtil(cmsBannersData, osmosBannerAdsData, channel) {
  const finalBannerData = cmsBannersData?.slots?.map(slotElement => {
    return {
      ...slotElement,
      component: {
        ...slotElement.component,
        banners: compactArrayofObjects(
          slotElement?.component?.banners?.map(bannerData => {
            if (bannerData?.bannerType !== 'EXTERNAL_AD' && bannerData?.isAdBanner) return {};
            if (bannerData?.bannerType === 'EXTERNAL_AD') {
              if (_isEmpty(osmosBannerAdsData.ads)) {
                return {};
              }
              const osmosAdsWtArray = osmosBannerAdsData.ads[bannerData?.adSpotId] || [];
              if (_isEmpty(osmosAdsWtArray)) {
                return {};
              }
              // const bannerDimension = `${Math.round(
              //   (bannerData?.width * cmsBannersData?.baseValue?.resolutionWidth) / 100
              // )}x${Math.round(
              //   (bannerData?.height * cmsBannersData?.baseValue?.resolutionHeight) / 100
              // )}`.toString();
              //  jioAdsTobeMerged = {
              //     jioAdImgUrl: bannerFound,
              //     cid: jioAdsWtArray[i]?.cid || '',
              //     
              //     clickthrough: jioAdsWtArray[i]?.clickthrough || '',
              //     impression: jioAdsWtArray[i]?.impression || '',
              //     desc: jioAdsWtArray[i]?.desc || '',
              //     isJioAdBanner: true
              //   };
              const osmosAd = osmosAdsWtArray[0];
              if (_isEmpty(osmosAd)) {
                return {};
              }
              const bannerUrl =
                channel === channels.MSITE
                  ? osmosAd?.elements?.mobile_image
                  : osmosAd?.elements?.desktop_image;
                const destinationUrl = osmosAd?.elements?.destination_url || '';
              if (bannerUrl) {
                return {
                  ...bannerData,
                  ...osmosAd,
                  bannerUrl,
                  clicktracker: osmosAd?.click_tracking_url || '',
                  ...(destinationUrl
                    ? {
                        hotspots: [
                          {
                            hotspotUrl: destinationUrl,
                            x: 0,
                            y: 0,
                            width: 100,
                            height: 100
                          }
                        ]
                      }
                    : {})
                };
              }
              return {};
            }
            return bannerData;
          })
        )
      }
    };
  });
  return finalBannerData;
}

export function cmsAndOsmosAdsBannersMapper(cmsBannersData, osmosBannerAdsData, channel) {
  return {
    ...cmsBannersData,
    data: {
      ...cmsBannersData?.data,
      page: {
        ...cmsBannersData?.data?.page,
        slots: cmsAndOsmosAdsBannersMergerUtil(
          { ...cmsBannersData?.data?.page, baseValue: cmsBannersData?.data?.baseValue },
          osmosBannerAdsData,
          channel
        )
      }
    }
  };
}
